import getESignerInfo from "./getESignData";
import { httpRequest } from "../../../../../httpRequest";
import { SESSION_STORAGE_ACCOUNT_KEY, ADVISOR_OBJECT_KEY, SESSION_STORAGE_CLIENT_ACCOUNT_INFO, getSessionStorageItem, setSessionStorageItem } from "../../../../../sessionStorage";

const reloadEsigner = async (formState, onSuccess, onFailure) => {
  const { pages: { retrieveAccount } } = formState;
  const { externalUserId } = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  const { account: { oneClickAccountId } } = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  const queryString = new URLSearchParams({
    branchNum: retrieveAccount.officeAccount.trim().split('-')[0],
    faNum: retrieveAccount.officeFa.trim().split('-')[1],
    accountNum: retrieveAccount.officeAccount.trim().split('-')[1],
    oneClickAccountId: oneClickAccountId,
    externalUserId: externalUserId,
    faOffice: retrieveAccount.officeFa.trim().split('-')[0],
  });

  const clientData = await httpRequest.get(`${process.env.REACT_APP_COVR_SERVICES_URL}/api/MorganStanley/GetClientAccountInfo?${queryString.toString()}`);

  if (!clientData || clientData.success === false || (clientData.content.status.toLowerCase() === "failure")) {
    await onFailure();
    return;
  }

  // handle response
  // update signer objects
  if (clientData.content.status.toLowerCase() === "success") {
    setSessionStorageItem(SESSION_STORAGE_CLIENT_ACCOUNT_INFO, clientData.content);
    const signers = await getESignerInfo(formState, clientData.content);
    await onSuccess(signers);
  }
}

export default reloadEsigner;


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/ESign/Helpers/reloadSigners.js